module.exports = __webpack_public_path__ + "img/sukarya_no.b7529bd0.png";